// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n\n.report .endtime{\n    text-align: right;\n}\n\n.play_speed{\n  width : 55px;\n}\n", ""]);
// Exports
module.exports = exports;
